/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Physio_LeadInputs */

const en_for_whom_physio_lead = /** @type {(inputs: For_Whom_Physio_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visits and home exercises.`)
};

const pl_for_whom_physio_lead = /** @type {(inputs: For_Whom_Physio_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wizyty i ćwiczenia do domu.`)
};

/**
* | output |
* | --- |
* | "Visits and home exercises." |
*
* @param {For_Whom_Physio_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_physio_lead = /** @type {((inputs?: For_Whom_Physio_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Physio_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_physio_lead(inputs)
	return en_for_whom_physio_lead(inputs)
});